// extracted by mini-css-extract-plugin
module.exports = {"center":"generic-error-modal_center__j476o","whiteSpace":"generic-error-modal_whiteSpace__6w_6n"};